import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

export class PathNoteForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            note: this.props.note,
            textInputError: null
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { note } = this.state;

        note[property] = e.target.value;

        this.setState({
            note: note
        });
    }

    onSave() {
        if (this.validInput()) {
            const { note } = this.state;
            this.props.onSave(note);
        }
    }

    validInput() {
        let errors = 0;
        let textInputError = null;

        const { note } = this.state;

        if ("" === note.text || null === note.text || undefined === note.text) {
            textInputError = 'error';
            errors++;
        }

        this.setState({
            textInputError: textInputError
        })

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { title } = this.props;
        const { note, textInputError } = this.state;

        if (undefined === note || null === note) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="beginDate" validationState={textInputError}>
                            <ControlLabel>Texto</ControlLabel>
                            <FormControl
                                type="text"
                                value={note.text}
                                placeholder="Introduza o Texto"
                                onChange={(e) => this.onChangeValue(e, "text")}
                            />
                            {textInputError !== null ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
